import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query omiliaRequestTypesPagination($page: Int, $pageSize: Int) {
  omiliaRequestTypesPagination(page: $page, pageSize: $pageSize) {
    omiliaRequestTypes {
      id
      name
      requestType {
        id
        name
      }
    }
    totalCount
    pageSize
  }
}`;

function getOmiliaRequestTypesPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.omiliaRequestTypesPagination);
}

export default getOmiliaRequestTypesPagination;
